'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  *{color: ', ';}\n  a{text-decoration:none;}\n  display: flex;\n  align-items: center;\n  text-decoration: none;\n  cursor: pointer;\n  height: 100%;\n  padding: 0px 10px;\n  text-align:center;\n  font-size: 1.2rem;\n  transition:all .1s;\n  :hover{\n    transition:all .1s;\n    background-color: ', ';\n  }\n  :not(:last-child){\n    margin-right: 10px;\n  }\n  :active{\n    transition:all .05s;\n    transform: scale(.98);\n  }\n'], ['\n  *{color: ', ';}\n  a{text-decoration:none;}\n  display: flex;\n  align-items: center;\n  text-decoration: none;\n  cursor: pointer;\n  height: 100%;\n  padding: 0px 10px;\n  text-align:center;\n  font-size: 1.2rem;\n  transition:all .1s;\n  :hover{\n    transition:all .1s;\n    background-color: ', ';\n  }\n  :not(:last-child){\n    margin-right: 10px;\n  }\n  :active{\n    transition:all .05s;\n    transform: scale(.98);\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var color = function color(props) {
  return props.color || 'inherit';
};
var hoverColor = function hoverColor(props) {
  return props.hover || 'rgb(25, 25, 25)';
};

var Link = _styledComponents2.default.div(_templateObject, color, hoverColor);

var NavLink = function NavLink(_ref) {
  var children = _ref.children,
      className = _ref.className,
      style = _ref.style,
      onClick = _ref.onClick,
      to = _ref.to,
      color = _ref.color,
      hover = _ref.hover;
  return _react2.default.createElement(
    Link,
    {
      className: className,
      style: style,
      onClick: onClick,
      href: to,
      color: color,
      hover: hover },
    to ? _react2.default.createElement(
      'a',
      { href: to },
      children
    ) : _react2.default.createElement(
      'div',
      null,
      children
    )
  );
};

exports.default = NavLink;